import { RulesConfig } from "./rules.models";

export enum IntegrationType {
  mailchimp = 1,
  silverpop = 2,
  hubspot = 3,
  pardot = 4,
  custom = 5,
  soap = 6,
  autopilot = 7,
  marketo = 8,
  acton = 9,
  salesforce = 10,
  hubspotCrm = 11,
  microsoftDynamics = 12,
  slack = 13,
  demandBase = 14,
}

export enum IntegrationCategory {
  MarketingAutomation,
  Crm,
  General,
}

export type IntegrationCrmItem = { [key: string]: string };

export interface IntegrationCrmTotalItemsRequest {
  targetListId: number;
  rulesObject: string;
  rules: RulesConfig;
  filterField: string;
  filterValue: string;
  filterValueType: IntegrationCrmFieldValueType;
}

export interface IntegrationCrmItemsRequest
  extends IntegrationCrmTotalItemsRequest {
  itemFields: string[];
  limit: number;
  offset: number;
}

export enum IntegrationCrmFieldValueType {
  Text = 1,
  Number = 2,
}

export interface Integration {
  id: IntegrationType;
  category: IntegrationCategory;
  name: string;
  logo: string;
  enabled: boolean;
  comingSoon?: boolean;
  description?: string;
  route: string;
  guideUrl?: string;
  goalAvailable: boolean;
  label: string;
  experienceAvailable: boolean;
  sendLeadsAvailable: boolean;
  sendActivityAvailable: boolean;
  supportDynamicTargetList: boolean;
}
